import http from '@/utils/http';

/**
 * 获取列表-xsh
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalApply/page',
        method: 'post',
        data
    });
};

/**
 * 导入-xsh
 */
export function importApi(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalMain/import',
        method: 'post',
        data
    });
};

/**
 * 导出-xsh
 */
export function exportApi(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalMain/export',
        method: 'post',
        data
    });
};

/**
 * 删除-xsh
 */
export function deleteApi(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalMain/delete',
        method: 'post',
        data
    });
};

/**
 * 详情-xsh
 */
export function detailApi(params) {
    return http({
        url: '/api-lcrm/goal/manage/goalApply/info',
        method: 'get',
        params
    });
};

/**
 * 目标提报申请-保存-xsh
 */
export function saveApi(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalApply/save',
        method: 'post',
        data
    });
};

/**
 * 目标提报对象-保存-xsh
 */
export function saveObjApi(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalMain/save',
        method: 'post',
        data
    });
};

/**
 * 查找目标类型下拉框：根据单据类型-xsh
 * CRM_GOAL_APPLY_TYPE 目标管理-单据类型
 * CRM_GOAL_APPLY_TYPE_RELATION 目标管理-单据类型与目标类型关联关系
 */
export function getGoalType(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalTypeList',
        method: 'post',
        data
    });
};

/**
 * 查找分组下拉框：根据目标类型-xsh
 */
export function getGroupList(data) {
    return http({
        url: '/api-lcrm/goal/manage/groupList',
        method: 'post',
        data
    });
};

/**
 * 根据条件查询组织列表-xsh
 */
export function getPart(data) {
    return http({
        url: '/api-lcrm/lcrm/org/info/selectByCondition',
        method: 'post',
        data
    });
};

/**
 * 目标提报提交审批-提交-xsh
 */
export function verityApi(params) {
    return http({
        url: '/api-lcrm/goal/apply/flow/submit',
        method: 'get',
        params
    });
};

/**
 * 目标提报申请-目标对象分页查询-xsh
 */
export function getGroupInfoList(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalApply/goalGroupPage',
        method: 'post',
        data
    });
};

/**
 * 目标提报申请-目标明细分页查询-xsh
 */
export function getGoalInfoList(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalApply/goalMainPage',
        method: 'post',
        data
    });
};

/**
 * 目标提报申请-审批校验-tr
 */
export function checkVerityApi(params) {
    return http({
        url: '/api-lcrm/goal/apply/flow/verify',
        method: 'get',
        params
    });
};

/**
 * 目标提报申请-目标提报申请-目标明细汇总-xsh
 */
export function getGoalMainCollect(data) {
    return http({
        url: '/api-lcrm/goal/manage/goalApply/goalMainCollect',
        method: 'post',
        data
    });
};

/**
 * 获取用户组织链-xsh
 */
export function getUserOrg(data) {
    return http({
        url: '/api-lcrm/goal/manage/userOrg',
        method: 'post',
        data
    });
};
